import { useState } from 'react';

export default function Footer() {
  return (
    <footer className="bg-gradient-to-b from-[#F8F6F3] to-[#F0EBE6] py-16">
      <div className="container mx-auto px-4 max-w-6xl">
        {/* Newsletter Section - Formulaire Brevo */}
        <div className="bg-white/80 rounded-2xl p-8 mb-12 shadow-lg border border-[#E8DDD4]">
          <div className="text-center mb-6">
            <h3 
              className="text-2xl sm:text-3xl font-bold text-[#8B4513] mb-3"
              style={{ fontFamily: 'Playfair Display, serif' }}
            >
              📧 Newsletter Les Carnets de Lolotte
            </h3>
            
            {/* Encart mis en valeur pour le texte d'accroche */}
            <div className="bg-gradient-to-r from-[#F8EDEA] via-[#FAF9F8] to-[#F8EDEA] rounded-xl p-5 mb-6 border border-[#C49B86]/30 shadow-sm max-w-2xl mx-auto">
              <div className="flex items-start justify-center gap-3">
                <span className="text-2xl mt-0.5">✨</span>
                <p 
                  className="text-base sm:text-lg text-[#8B4513] font-semibold leading-relaxed"
                  style={{ fontFamily: 'Playfair Display, serif' }}
                >
                  Inscrivez-vous à la newsletter et bénéficiez à vie de 10 % de réduction sur la boutique.
                </p>
              </div>
            </div>
          </div>
          
          {/* Nouveau formulaire Brevo avec hauteur 450px */}
          <div className="max-w-lg mx-auto">
            <iframe 
              width="540" 
              height="450" 
              src="https://e836bcd2.sibforms.com/serve/MUIFAHli5LCtGrb_DzrdpFL_Vta8IRZBxLz3ojPUhQ8AeHWdaKW_2tZu3Gud0EkEDqJhH3mhQI-0qHsXLGO_z1TgGrW89M66N-hSsMK5Af1p4eeKy3EglShFwrJfA47meiqHxLED3xgRkRfEjDHGhD2U1KW6BLK7LF5eduSpauq-xM0KlgOcNNsRdNaRJvuf1y7C_9NVvt1b8Lv2Iw==" 
              frameborder="0" 
              scrolling="auto" 
              allowfullscreen 
              style={{display:'block', margin:'auto', maxWidth:'100%'}}
              className="rounded-lg shadow-sm w-full"
            />
          </div>
        </div>

        {/* Rest of footer content */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          {/* Contact */}
          <div className="text-center md:text-left">
            <h3 
              className="text-xl font-bold text-[#8B4513] mb-4"
              style={{ fontFamily: 'Playfair Display, serif' }}
            >
              📧 Contact
            </h3>
            <div className="space-y-2 text-[#C49B86]">
              <p>✉️ contact@lescarnetsdelolotte.com</p>
              <p>📞 Sur demande par email</p>
              <p>📍 Livraison France entière</p>
            </div>
          </div>

          {/* Navigation */}
          <div className="text-center">
            <h3 
              className="text-xl font-bold text-[#8B4513] mb-4"
              style={{ fontFamily: 'Playfair Display, serif' }}
            >
              🔗 Navigation
            </h3>
            <div className="space-y-2">
              <div><a href="/" className="text-[#C49B86] hover:text-[#8B4513] transition-colors">Accueil</a></div>
              <div><a href="/boutique" className="text-[#C49B86] hover:text-[#8B4513] transition-colors">Boutique</a></div>
              <div><a href="/offres-a-prix-doux" className="text-[#E8B4B8] hover:text-[#8B4513] transition-colors font-bold">🎁 Offres à prix doux</a></div>
              <div><a href="/about" className="text-[#C49B86] hover:text-[#8B4513] transition-colors">À propos</a></div>
              <div><a href="/contact" className="text-[#C49B86] hover:text-[#8B4513] transition-colors">Contact</a></div>
              <div><a href="/personnalisations" className="text-[#C49B86] hover:text-[#8B4513] transition-colors">Personnalisations</a></div>
            </div>
          </div>

          {/* Informations légales */}
          <div className="text-center md:text-right">
            <h3 
              className="text-xl font-bold text-[#8B4513] mb-4"
              style={{ fontFamily: 'Playfair Display, serif' }}
            >
              ⚖️ Informations
            </h3>
            <div className="space-y-2">
              <div><a href="/mentions-legales" className="text-[#C49B86] hover:text-[#8B4513] transition-colors">Mentions légales</a></div>
              <div><a href="/livraison" className="text-[#C49B86] hover:text-[#8B4513] transition-colors">Livraison & Retours</a></div>
              <div><a href="/paiement-securise" className="text-[#C49B86] hover:text-[#8B4513] transition-colors">Paiement sécurisé</a></div>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-[#E8DDD4] pt-6 text-center">
          <p className="text-[#C49B86] text-sm mb-2" style={{ fontFamily: 'Playfair Display, serif' }}>
            Les Carnets de Lolotte proposent des créations artisanales en livres pliés, entre décoration poétique et cadeaux chargés de sens.
          </p>
          <p className="text-[#C49B86] text-sm">
            © 2024 Les Carnets de Lolotte - Créations artisanales uniques - Tous droits réservés
          </p>
          <p className="text-xs text-[#C49B86] mt-2">
            <a href="https://readdy.ai/?origin=logo" target="_blank" rel="noopener noreferrer" className="hover:text-[#8B4513] transition-colors">
              Powered by Readdy
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
